var EventEmitter = (function () {
    function EventEmitter() {
        this.listeners = {};
    }
    EventEmitter.prototype.on = function (event, listener) {
        if (!this.listeners[event]) {
            this.listeners[event] = [];
        }
        this.listeners[event].push(listener);
    };
    EventEmitter.prototype.emit = function (event, arg) {
        if (this.listeners[event]) {
            for (var _i = 0, _a = this.listeners[event]; _i < _a.length; _i++) {
                var listener = _a[_i];
                try {
                    listener(arg);
                }
                catch (error) {
                    console.error("Error occurred in listener for ".concat(String(event), ":"), error);
                }
            }
        }
    };
    return EventEmitter;
}());
export { EventEmitter };
